import React from 'react';
import {formatPackageDurationLabel} from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';

export const DefaultTerms = ({selectedPackage, sectionRef, data, handleBackClick}) => {
  const packageDuration = selectedPackage.packageDuration;
  const packageDurationLabel = formatPackageDurationLabel(
    packageDuration,
    selectedPackage.packageDurationUnit,
  );

  if (data.length > 4)
    data[2].content[0].description = ` תוקף החבילה למשך עד ${packageDurationLabel} ממועד תחילת תוקפה (להלן: "תקופת החבילה"). עם תום תקופת
החבילה תסתיים החבילה באופן מיידי ואוטומטי. במקרה בו במועד סיום החבילה תשהה בחו"ל תיחסם לגלישה בחו"ל, למעט לקוח עסקי
לא מפוצל הפתוח לגלישה בחו"ל בטופס גישה לשירותים אשר יחוייב עפ"י תעריפי ${window.Config.brand_Name_HE} חו"ל כפי שיהיו ב${window.Config.brand_Name_HE} מעת לעת והמפורטים
באתר האינטרנט של ${window.Config.brand_Name_HE} בכתובת ${window.location.origin}. ללא הסדר בחו"ל (לרבות עם סיום החבילה) תיחסם לגלישה בחו"ל. לקוח עסקי שאינו מפוצל הפתוח לגלישה בחו"ל בטופס גישה לשירותים לא ייחסם.`;
  else {
    data[1].content[0].description = ` תוקף החבילה למשך עד ${packageDurationLabel} ממועד תחילת תוקפה (להלן: "תקופת החבילה"). עם תום תקופת
החבילה תסתיים החבילה באופן מיידי ואוטומטי. במקרה בו במועד סיום החבילה תשהה בחו"ל תיחסם לגלישה בחו"ל, למעט לקוח עסקי
לא מפוצל הפתוח לגלישה בחו"ל בטופס גישה לשירותים אשר יחוייב עפ"י תעריפי ${window.Config.brand_Name_HE} חו"ל כפי שיהיו ב${window.Config.brand_Name_HE} מעת לעת והמפורטים
באתר האינטרנט של ${window.Config.brand_Name_HE} בכתובת ${window.location.origin}. ללא הסדר בחו"ל (לרבות עם סיום החבילה) תיחסם לגלישה בחו"ל. לקוח עסקי שאינו מפוצל הפתוח לגלישה בחו"ל בטופס גישה לשירותים לא ייחסם. `;
  }
  let TermsDataDefault = data;

  if (!selectedPackage.dataForApp.hasDataForApp) {
    TermsDataDefault = TermsDataDefault.slice(0, -1);
  }

  const createDefaultContent = () => {
    const defaultContent = TermsDataDefault.map((section, sectionI) => {
      let sectionId = 'section-' + (sectionI + 1);
      return (
        <div className='section' ref={(el) => (sectionRef.current[sectionI + 1] = el)} id={sectionId}>
          <div className='mainTitle'>
            <h1>
              {sectionI + 2}. {section.mainTitle}
            </h1>
          </div>

          {section.content.map((c, i) => {
            if (c.title) {
              return (
                <>
                  <div className='titleAndDescription'>
                    <li className='title'>
                      {sectionI + 2}.{i + 1}. {c.title}
                    </li>
                    <li className='description'>{c.description}</li>
                  </div>
                </>
              );
            } else {
              if (c.description) {
                if (c.subDescription.length) {
                  return (
                    <>
                      <div className='descriptionAndSubDescription'>
                        <li className='description'>
                          {sectionI + 2}.{i + 1}. {c.description}
                        </li>

                        {c.subDescription.map((sub, index) => {
                          return (
                            <>
                              <li className='subDescription'>
                                {sectionI + 2}.{i + 1}.{index + 1}. {sub}
                              </li>
                            </>
                          );
                        })}
                      </div>
                    </>
                  );
                } else {
                  return (
                    <>
                      <div className='onlyDescription'>
                        <li className='description'>
                          {sectionI + 2}.{i + 1}.{c.description}
                        </li>
                      </div>
                    </>
                  );
                }
              }
            }
          })}
          <a className='title' style={{cursor: 'pointer'}} onClick={() => handleBackClick('top')}>
            חזרה למעלה
          </a>
        </div>
      );
    });
    return defaultContent;
  };
  const content = createDefaultContent();
  return content;
};
